<template>
    <v-dialog
            scrollable
            v-model="visible"
            max-width="900px"
            :fullscreen="fullscreen"
            :persistent="true"
    >
        <v-card>
            <v-toolbar flat dense>
                <v-toolbar-title class="subheading">{{"失信论文添加"}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="fullscreen=!fullscreen">
                    <v-icon>fullscreen</v-icon>
                </v-btn>
            </v-toolbar>

            <v-divider style="max-height: 1px"/>
            <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

            <v-card-text>
                <v-form v-model="formValid" ref="formRef" lazy-validation>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                        label="论文标题"
                                        :rules="rules.required"
                                        v-model="item.title"
                                        hint="不超过200个字"
                                        persistent-hint
                                />
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-menu
                                        ref="pubDatePickerRef"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="pubDateMenu"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px"
                                >
                                    <v-text-field
                                            slot="activator"
                                            label="发表时间"
                                            required
                                            v-model="item.pubDate"
                                            :rules="rules.pubDate"
                                            hint="格式YYYY-MM-DD, 如：2018-10-01"
                                            persistent-hint
                                    />

                                    <v-date-picker
                                            v-model="pubDate"
                                            locale="zh-cn"
                                            @change="nv => item.pubDate= nv"
                                    />
                                </v-menu>
                            </v-flex>

                            <v-flex xs6>
                                <v-text-field
                                        label="期刊名称"
                                        :rules="rules.required"
                                        v-model="item.sourceName"
                                        hint="不超过100个字"
                                        persistent-hint
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
                <v-btn color="primary" @click.native="onSave">保存
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import mixin from '@/mixin'

    const baseURI = '/api/integrity/integrity/paper/edit';

    export default {
        props: ['integId','dbid'],
        mixins: [mixin.edit(baseURI)],

        data() {
            return {
                formValid: false,
                item: {},
                freshItem: {
                    "title": null,
                    "pubDate": null,
                    "sourceName": null,
                    "integId":null
                },
                pubDateMenu: false,
                pubDate: null,

                /**
                 * 验证规则
                 */
                rules: {
                    required: [
                        v => !!v || '必填项。'
                    ],
                    title: [
                        v => !!v || '必填项。',
                        v => (v && v.length <= 200) || '长度必须小于200个字符。'
                    ],
                    sourceName: [
                        v => !!v || '必填项。',
                        v => (v && v.length <= 100) || '长度必须小于100个字符。'
                    ],
                    pubDate: [
                        v => !!v || "必填项。",
                        v => window.xutil.regexpDate().test(v) || '日期格式错误'
                    ]
                }
            }
        },

        created() {

        },

        watch: {
            integId(v) {
                if (!v) {
                    this.integId && this.integId.length > 0 && this.get();
                }
            },
            dbid(v) {
                if (!v) return;
                this.axios
                    .get(`${baseURI}/paper/edit/${this.dbid}`)
                    .then(
                        rsp => this.item = rsp.data.items
                    )
            }
        },

        computed: {

        },

        methods: {
            beforeSendData(item){
                item.integId= this.integId;
            }
        }
    }
</script>